import CardData from './CardData';
import type { CardProperties, CardRawData } from './CardData';
import type { GeoFieldPoint } from './GeoLocation';
import StageList from './StageList';
import type { StageListItem } from './StageData';
import {LocaleService} from "../common/LocaleService";

/** Datos crudos de un camino, tal cual llegan del detalle REST. */
export interface RouteCardRawData extends CardRawData {
    route_id?: string;
    texto_intro?: { value: string };
    stage_list?: StageListItem[];
}

/**
 * CardData - Data from REST service.
 *
 * Data wrapper for object types:
 * - Route
 * - Stage
 */
class RouteCard extends CardData {

    // geo_bounds lo declara CardData. Solo se estrecha el tipo de data, que
    // `declare` no emite.
    declare data?: RouteCardRawData;
    
    constructor(type: string, properties: CardProperties, data?: RouteCardRawData) {
      // Call parent constructor.
      super(type, properties, data);
      
      // Add extra properties.
      if (data) {
        if (!data.geo_location && data.geo_bounds && data.geo_bounds.lat && data.geo_bounds.lon) {
          // Geo bounds contains center lat / lon so we can just...
          // La guarda de arriba comprueba que lat y lon estan presentes.
          this.geo_location = data.geo_bounds as GeoFieldPoint;
        }

        if (data.texto_intro) {
            this.extra_html = LocaleService.decodeHtmlEntities(data.texto_intro.value);
        }
      }
    }
    
    /**
     * Returns route_id
     */
    getMapId(): string | null | undefined {
      return this.data ? this.data.route_id : null;
    }    
    
    /**
     * Gets list of stages.
     */
    getStageList(): StageList | undefined {
      if (this.data && this.data.stage_list) {
          return StageList.fromListItems(this.data.stage_list);
      }
      return undefined;
    }

}

export default RouteCard;
